type Args = {
  retentionFlowEnabled: boolean;
  isPaused: boolean;
  isLoggedIn: boolean;
  isPremiumTier: boolean;
  areAllPlansDowngrading: boolean;
};

/**
 * Switching to free is an alternative to unsubscribing even where pause is unavailable, so the
 * retention modal also opens for publications whose only offer is that switch. Without it a paying
 * subscriber on such a publication reaches a confirm dialog with no way to keep free access.
 */
export const showUnsubscribeRetentionModal = ({
  retentionFlowEnabled,
  isPaused,
  isLoggedIn,
  isPremiumTier,
  areAllPlansDowngrading,
}: Args) => {
  const canSwitchToFree = isLoggedIn && isPremiumTier && !areAllPlansDowngrading;

  return !isPaused && (retentionFlowEnabled || canSwitchToFree);
};
